export const LOCAL_SOCKET_URL = "http://localhost:3003";
export const STAGE_SOCKET_URL = "https://staging-communication.apollosoft.co";
export const PROD_SOCKET_URL = "https://communication.apollosoft.co";

export const USER_CRM_TOKEN =
  localStorage.getItem("CRM_TOKEN") || "1ef3041e-2fb6-41b6-9136-16873a3d90db";

export enum ContactTypes {
  TECHNICIAN = 0,
  CUSTOMER = 1,
}

export const DEFAULT_CONTACT_TYPE = ContactTypes.TECHNICIAN;

let SERVER_URL = LOCAL_SOCKET_URL;
if (process.env.REACT_APP_API_URL !== undefined) {
  SERVER_URL =
    process.env.REACT_APP_API_URL.indexOf(
      "staging-callcenter-admin.apollosoft"
    ) >= 0
      ? STAGE_SOCKET_URL
      : PROD_SOCKET_URL;
}

export const COMMUNICATION_SERVER_URL = SERVER_URL;

const SMS_STATUS = {
  accepted: 0,
  queued: 1,
  sending: 2,
  sent: 3,
  failed: 4,
  delivered: 5,
  undelivered: 6,
  receiving: 7,
  received: 8,
  read: 9, // (WhatsApp only)
};

export const SMS_STATUS_PROCESS = {
  [SMS_STATUS.accepted]: true,
  [SMS_STATUS.queued]: true,
  [SMS_STATUS.sending]: true,
  [SMS_STATUS.sent]: true,
};

export const SMS_STATUS_RECEIVED = {
  [SMS_STATUS.delivered]: true,
  [SMS_STATUS.receiving]: true,
  [SMS_STATUS.received]: true,
  [SMS_STATUS.read]: true,
};

export const SMS_STATUS_ERROR = {
  [SMS_STATUS.failed]: true,
  [SMS_STATUS.undelivered]: true,
};

export const AVALABLE_DEPARTMENTS = [
  {
    id: 3,
    name: "HVAC",
    phone: "+18559994417",
  },
  {
    id: 110,
    name: "5 Star Appliance",
    phone: "+18557314952",
  },
  {
    id: 1,
    name: "Appliance Repair",
    phone: "+18554611149",
  },
  {
    id: 9,
    name: "Plumbing",
    phone: "+18889090120",
  },
  {
    id: 4,
    name: "Air Duct Cleaning",
    phone: "+18006865038 ",
  },
  {
    id: 10,
    name: "Electricians",
    phone: "+18005688664",
  },
];
